import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import posts from "../blogIndex.json";
import { linkPreviewConfig, previewableLinks } from "../data";

const MarkdownLink = ({ href, children }) => {
  const [preview, setPreview] = useState({ show: false, url: '' });
  const [position, setPosition] = useState({ x: 0, y: 0 });

  if (!previewableLinks.includes(href)) {
    return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
  }

  const handleMouseEnter = (e) => {
    try {
      const domain = new URL(href).hostname;
      const config = linkPreviewConfig[domain];
      let faviconUrl = '';
      if (config === null) return;
      else if (typeof config === 'string') faviconUrl = config;
      else faviconUrl = `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
      setPreview({ show: true, url: faviconUrl });
    } catch {
      return;
    }
  };

  const handleMouseLeave = () => setPreview(p => ({ ...p, show: false }));
  const handleMouseMove = (e) => setPosition({ x: e.clientX, y: e.clientY });

  return (
    <>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
      >
        {children}
      </a>
      <img
        src={preview.url}
        alt="Favicon preview"
        className={`favicon-preview ${preview.show && preview.url ? 'is-visible' : ''}`}
        style={{
          top: `${position.y}px`,
          left: `${position.x}px`,
          transform: 'translate(-50%, calc(-100% - 50px))'
        }}
      />
    </>
  );
};

export default function PostPage() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="container" style={{ paddingTop: '4rem' }}>
        <p style={{ color: 'var(--text-muted)' }}>post not found.</p>
        <Link to="/" className="back-link" style={{ marginTop: '1rem', display: 'inline-block' }}>
          ← back
        </Link>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="post-page">
        <h1>{post.title}</h1>
        <span className="post-date">{post.date}</span>
        <hr />
        <ReactMarkdown
          children={post.content}
          components={{ a: MarkdownLink }}
        />
        <hr />
        <Link to="/" className="back-link">← back</Link>
      </div>
    </div>
  );
}
